import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { showToaster } from "../../../common/common";
import PostRequest from "../../../services/PostRequest";
import "../../../styles/auth.css";

export const SignIn = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSignIn = async (data) => {
    try {
      setIsLoading(true);
      const option = {
        showLoader: "login-id",
        auth: false,
      };

      const response = await PostRequest("/users/login", data, option);

      showToaster("welcome back!", "success");

      window.localStorage.setItem("TOKEN", response.token);
      window.localStorage.setItem("AUTH", JSON.stringify(response.user));

      navigate("/dashboard");
    } catch (error) {
      console.log("error", error.message);
      showToaster(error.message, "error");
      setIsLoading(false);
    }
  };

  const validate = (values) => {
    const errors = {};
    if (!values.email) {
      errors.email = "Email Required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = "Invalid email address";
    }
    if (!values.password) errors.password = "Password Required";
    return errors;
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validate,
    onSubmit: handleSignIn,
  });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="auth" data-screen-label="Sign In">
      <div className="auth__main">
        <div className="auth__card">
          <img
            className="auth__logo auth__logo--color"
            src="/assets/brand/multicartapi-logo.png"
            alt="MultiCartAPI"
          />
          <img
            className="auth__logo auth__logo--white"
            src="/assets/brand/multicartapi-logo-white.png"
            alt="MultiCartAPI"
          />
          <h1>Sign in</h1>
          <p className="auth__sub">
            Welcome back. Enter your details to access your dashboard.
          </p>

          <form className="auth__form" onSubmit={formik.handleSubmit}>
            <div className="mca-field">
              <label className="mca-label" htmlFor="si-email">
                Email <span className="req">*</span>
              </label>
              <div className="mca-input-group">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="5" width="18" height="14" rx="2" />
                  <path d="m3 7 9 6 9-6" />
                </svg>
                <input
                  className="mca-input"
                  id="si-email"
                  type="email"
                  name="email"
                  placeholder="you@company.com"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required
                />
              </div>
              {formik.touched.email && formik.errors.email && (
                <span className="mca-error" style={{ color: "var(--mca-danger)" }}>
                  {formik.errors.email}
                </span>
              )}
            </div>

            <div className="mca-field">
              <label className="mca-label" htmlFor="si-pw">
                Password <span className="req">*</span>
              </label>
              <div className="pw-field">
                <input
                  className="mca-input"
                  id="si-pw"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="••••••••"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required
                />
                <button
                  type="button"
                  className={`mca-iconbtn pw-field__toggle ${showPassword ? "is-revealed" : ""}`}
                  onClick={togglePasswordVisibility}
                  aria-label="Show password"
                >
                  <svg
                    className="ico-on"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
                    <circle cx="12" cy="12" r="2.6" />
                  </svg>
                  <svg
                    className="ico-off"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3l18 18" />
                    <path d="M10.6 10.6a2 2 0 0 0 2.8 2.8" />
                    <path d="M9.4 5.2A9.6 9.6 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-3.2 4M6.2 6.2A17 17 0 0 0 2 12s3.5 7 10 7a9.5 9.5 0 0 0 3-.5" />
                  </svg>
                </button>
              </div>
              {formik.touched.password && formik.errors.password && (
                <span className="mca-error" style={{ color: "var(--mca-danger)" }}>
                  {formik.errors.password}
                </span>
              )}
            </div>

            <div className="auth__row">
              <label className="mca-check">
                <input type="checkbox" />
                <span className="mca-check__box">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                </span>
                Remember me
              </label>
              <a
                className="mca-btn mca-btn--link mca-btn--sm"
                href="/password/forgot"
              >
                Forgot password?
              </a>
            </div>

            <button
              className="mca-btn mca-btn--primary"
              id="login-id"
              type="submit"
              style={{ width: "100%", marginTop: "4px" }}
              disabled={isLoading || formik.isSubmitting}
            >
              <span
                className="mca-btn__spin"
                hidden={!isLoading && !formik.isSubmitting}
              >
                <span className="mca-spinner"></span>
              </span>
              <span className="mca-btn__label">
                {isLoading || formik.isSubmitting ? "Signing in..." : "Sign in"}
              </span>
            </button>
          </form>

          <div className="auth__foot">
            Don't have an account?{" "}
            <a href="/sign-up">Create one</a>
          </div>
        </div>
      </div>

      <div className="auth__brand">
        <img
          className="auth__brand-logo"
          src="/assets/brand/multicartapi-logo-white.png"
          alt="MultiCartAPI"
        />
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <h2 id="brand-heading">
            {typeof window !== "undefined" &&
            window.MCA_AUTH?.h2 ? (
              <span
                dangerouslySetInnerHTML={{
                  __html: window.MCA_AUTH.h2,
                }}
              />
            ) : (
              "The same product, end to end."
            )}
          </h2>
          <p id="brand-description">
            {typeof window !== "undefined" &&
            window.MCA_AUTH?.p ? (
              window.MCA_AUTH.p
            ) : (
              "Test, schedule, and ship marketplace data - Amazon and Officeworks - from one dashboard that matches multicartapi.com."
            )}
          </p>
        </div>
      </div>

      <div data-toast-host></div>
    </div>
  );
};
